<template>
  <div
    class="px-6 py-4 rounded-md bg-error-200 text-error-700 text-14"
    role="alert"
  >
    <div class="flex items-center mb-2 font-bold">
      <exclamation-triangle-outlined
        class="h-4 mr-2"
      ></exclamation-triangle-outlined>
      {{ translations.error_title }}
    </div>
    <div class="pl-4">
      <ul class="list-disc text-12">
        <li>{{ translations.error_max }}</li>
        <li>{{ translations.error_size }}</li>
        <li>{{ translations.error_format }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import exclamationTriangleOutlined from "@/assets/exclamation-triangle-outlined.svg";
export default {
  name: "UploaderError",
  props: {
    translations: {
      type: Object,
    },
  },
  components: {
    exclamationTriangleOutlined,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/tailwind.scss";
</style>
